import * as angular from 'angular';
import { FullscreenWizardModule } from '@buildium/angularjs-core/dist/components/fullscreen-wizard';
import { BdEsignatureRequestSignModalComponent } from './esignature-request-sign-modal.component';
import { EsignaturesConstantsModule } from '../../constants/esignatures-constants.module';
import { EsignaturesAccountServiceModule } from '../../services/esignatures-account/esignatures-account.module';
import { HellosignEmbeddedIframeModule } from '../hellosign-embedded-iframe/hellosign-embedded-iframe.module';

export const EsignatureRequestSignModalModule = angular.module('buildium.manager.leases.esignatures.components.esignaturesRequestSignModalModule', [
    FullscreenWizardModule.name,
    EsignaturesConstantsModule.name,
    EsignaturesAccountServiceModule.name,
    HellosignEmbeddedIframeModule.name
])
    .component('bdEsignatureRequestSignModalComponent', new BdEsignatureRequestSignModalComponent());
